



























































import { Component, Vue, Prop } from 'vue-property-decorator';

import AutoCompleteDesktop       from '@/components/ui/AutoCompleteDesktop.vue';
import MapTrayFooter       from '@/components/map/MapTrayFooter.vue';

@Component({
  name: 'MapTray',
  components: {
    AutoCompleteDesktop,
    MapTrayFooter
  }
})

export default class MapTray extends Vue {
  @Prop({ required: true, default: false }) readonly hasStateContext!: boolean;
  @Prop({ required: false, default: '' }) readonly stateContextTitle!: string;

  @Prop({ required: true, default: false }) readonly hasBackRoute!: boolean;
  @Prop({ required: false, default: '' }) readonly backRoute!: string;

  showWelcome = false;

  get isTrayOpen() {
    return this.$store.state.uiState.isTrayOpen;
  }

  get autocompleteHasFocus() {
    return this.$store.state.uiState.autocompleteHasFocus;
  }

  toggleTray() {
    const nextState = !this.isTrayOpen;
    this.$store.dispatch('setIsTrayOpen', nextState);
  }

  bubbleGeolocationError(event: Event) {
    this.$emit("geolocationerror")
  }

  handleCloseTray() {
    if (this.isTrayOpen){
      this.toggleTray();
    }
  }


};

